import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../pages/AuthContext';

const actions = [
  { label: 'Events',    icon: '📅', path: '/events' },
  { label: 'Books',     icon: '📚', path: '/books' },
  { label: 'Donate',    icon: '💛', path: '/donate',   requiresAuth: true },
  { label: 'Articles',  icon: '📖', path: '/articles', requiresAuth: true },
  { label: 'Videos',    icon: '▶️',  path: '/youtube',  requiresAuth: true },
  { label: 'Community', icon: '🕉️', path: '/vaikhanasam' },
];

const MobileQuickActions = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="vrv-quick-actions" role="navigation" aria-label="Quick actions">
      {actions.map(({ label, icon, path, requiresAuth }) => {
        const href = requiresAuth && !isAuthenticated ? '/login' : path;
        return (
          <Link
            key={label}
            to={href}
            className="vrv-quick-chip"
            aria-label={label}
          >
            <span className="chip-icon" aria-hidden="true">{icon}</span>
            {label}
          </Link>
        );
      })}
    </div>
  );
};

export default MobileQuickActions;
